module.exports = __webpack_public_path__ + "static/img/-6_54.ea2d800.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/issue6/-6_54.jpg
// module id = W3hW
// module chunks = 7